
import React, { useEffect } from 'react';
import mapboxgl from 'mapbox-gl';
import { Region } from '../../../data/types/region-types';
import { getUnreachedGroupsByRegion } from '../../../data/utils/region-utils';

interface UnreachedPinsProps {
  map: mapboxgl.Map;
  region: Region;
}

const UnreachedPins: React.FC<UnreachedPinsProps> = ({ map, region }) => {
  useEffect(() => {
    if (!map || !region) return;

    const unreachedGroups = getUnreachedGroupsByRegion(region.region_id);
    const markers: mapboxgl.Marker[] = [];

    unreachedGroups.forEach(group => {
      if (!group.coordinates) return;

      // Create marker element with consistent red color
      const el = document.createElement('div');
      el.className = 'unreached-pin';
      
      // Add pulse effect with red color
      el.innerHTML = `
        <div class="relative">
          <div class="absolute inset-0 animate-ping rounded-full bg-red-600 opacity-75"></div>
          <div class="relative rounded-full h-4 w-4 bg-red-700"></div>
        </div>
      `;

      // Create popup with red-themed styling
      const popup = new mapboxgl.Popup({
        closeButton: false,
        closeOnClick: true,
        offset: [0, -10]
      })
      .setHTML(`
        <div class="p-2 bg-white/90 backdrop-blur-sm rounded text-sm border border-red-200">
          <div class="font-bold text-red-700">${group.name}</div>
          <div class="text-xs mt-1 text-red-600">Population: ${group.population.toLocaleString()}</div>
          <div class="text-xs text-red-600">Evangelical: ${group.evangelical_percentage}%</div>
        </div>
      `);

      // Create and add marker
      const marker = new mapboxgl.Marker({
        element: el,
        anchor: 'center'
      })
      .setLngLat(group.coordinates)
      .setPopup(popup)
      .addTo(map);

      markers.push(marker);
    });

    return () => {
      markers.forEach(marker => marker.remove());
    };
  }, [map, region]);

  return null;
};

export default UnreachedPins;
